module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "file_025"
    }
  }, [_vm._v("2. Rolling")])]), _c('a', {
    attrs: {
      "id": "file_025"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Most of the needle-felted animal projects in this book start out with a round shape. Take a palm full of wool and tear it into smaller pieces, layering these pieces one on top of the other. When you have a nice pillow of wool, fold the top edge down and the side edges in "), _c('strong', [_vm._v("(C)")]), _vm._v(". Press and fold. Keep folding and pressing the top down and edges in until you have a nice, compact round shape. Needle all around the surface to hold the wool in place. Roll it around in the palm of your hand like a piece of dough.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-03.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d49c90e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_025.vue
// module id = 126
// module chunks = 0